import React from 'react';
import htmr from 'htmr';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import styles from './JobCard.module.scss';
import { removeStyleAttribute } from '../../../../utils/helpers';
import { useWindowSize } from '../../../../utils/hooks';
import { mobileWidth } from '../../../../utils/constants';

export function CardSummary({ text, length, onClick, onBlur, jobId }) {
  const { t } = useTranslation();
  const size = useWindowSize();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();

  if (text === null || text === undefined) {
    text = '';
  }

  const handleReadMore = () => {
    if (size.width < mobileWidth) {
      navigate(`${isAuthenticated ? '/dashboard' : ''}/jobs/${jobId}`);
    } else {
      onClick();
    }
  };

  return (
    <div className={styles.CardSummary}>
      <div data-testid="text" className={styles.CardSummary__desc}>
        {htmr(removeStyleAttribute(text?.length > length ? `${text.substring(0, length)}...` : text))}
      </div>
      <div
        data-testid="btn"
        role="button"
        tabIndex={0}
        onClick={handleReadMore}
        onBlur={onBlur}
        aria-hidden="true"
        className={styles.CardSummary__ReadMore}
      >
        {t('common.general.readmore')}
      </div>
    </div>
  );
}
